import { render, staticRenderFns } from "./ClientInfo.vue?vue&type=template&id=e0261920&scoped=true"
import script from "./ClientInfo.vue?vue&type=script&lang=ts"
export * from "./ClientInfo.vue?vue&type=script&lang=ts"
import style0 from "./ClientInfo.vue?vue&type=style&index=0&id=e0261920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0261920",
  null
  
)

export default component.exports